{{#with survey}}
  {{#if sections }}
    <div class="sections" data-survey-container='survey' aria-label="{{t 'surveyAccessibility.survey'}}">
      {{#each sections }}
        {{#if (equal @index ../../section_number)}}
          {{#if (equal false ../../hide_title)}}{{#if title }}<div class="title {{#if ../../section_title_headerlevel}}{{../../section_title_headerlevel}}{{else}}h2{{/if}}">{{ title }}</div>{{/if}}{{/if}}
          {{#if (equal false ../../hide_title)}}{{#if description }}<div class="description {{#if ../../section_description_headerlevel}}{{../../section_description_headerlevel}}{{else}}h3{{/if}}">{{ description }}</div>{{/if}}{{/if}}
          {{#if questions }}
            <div class="questions" aria-label="{{t (concat 'surveyAccessibility.sectionLabel' (indexToCount @index))}}">
              {{#each questions }}
                <div class="question-answer-set" data-survey-container='question'>
                  {{#if text }}
                    <div class="question {{#if ../../question_headerlevel}}{{../../question_headerlevel}}{{else}}h3{{/if}}" aria-label="{{t (concat 'surveyAccessibility.questionLabel' (indexToCount @index))}}: {{text}}">
                      {{ text }}
                    </div>
                  {{/if}}
                  {{#if answers }}
                    <div class="answers">
                      <div class="btn-group-{{@index}}" data-toggle="buttons">
                        <fieldset class="choices__fieldset">
                          <div 
                              {{#compare ../response_type "!==" "multiple_selection"}}
                              role="radiogroup"
                              {{/compare}} aria-label="{{t (concat 'surveyAccessibility.questionLabel' (indexToCount @index))}}: {{text}}"
                            >
                            {{#each answers }}
                              <label class="btn btn-primary answer choices__label {{#compare ../response_type "===" "multiple_selection"}}multiple{{/compare}}" tabindex="0" aria-label="{{t (concat 'surveyAccessibility.optionLabel' (indexToCount @index))}}: {{text}}" aria-checked="false" data-index="{{indexToCount @index}}" role="{{#compare ../response_type "===" "multiple_selection"}}checkbox{{else}}radio{{/compare}}">
                                <div class="input-icon">
                                  {{>icon uuid=id index=@index prefix=(subIf ../icon_prefix  ../icon_prefix 'far') name=(subIf ../icon_name ../icon_name (subIf ../response_type  "fa-square" "fa-circle" "===" "multiple_selection")) size=../icon_size}}
                                  {{>icon uuid=id index=@index prefix=(subIf ../icon_prefix ../icon_prefix 'far') name=(subIf ../icon_name_selected ../icon_name_selected (subIf ../response_type  "fa-check-square" "fa-dot-circle" "===" "multiple_selection")) size=../icon_size}}
                                </div>
                                <input type={{#compare ../response_type "===" "multiple_selection"}}"checkbox"{{else}}"radio"{{/compare}}
                                  name={{ ../id }} class="answer" value="{{ id }}" data-question-id="{{ ../id }}"
                                  data-answer-id="{{ id }}" data-index="{{indexToCount @index}}" tabindex="-1"
                                />
                                <span class="text">{{ text }}</span>
                              </label>
                            {{/each}}
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  {{/if}}
                </div>
              {{/each}}
            </div>
          {{/if}}
        {{/if}}
      {{/each}}
      {{#compare sections.length ">" 1}}
        <button id="submitQuestions" role="button">Send</button>
      {{else}}
        {{#compare sections.0.questions.length ">" 1}}
        <button id="submitQuestions" role="button">Send</button>
        {{/compare}}
      {{/compare}}
    </div>
  {{/if}}
{{/with}}
